import React from 'react';
import { BrowserRouter as Router, Route} from 'react-router-dom';

import Join from './components/Join/Join';
import Chat from './components/Chat/Chat';

const App = () => (
    <Router> 
        {/* First time user comes, Join Component. Details are passed here */}
        <Route path="/" exact component={Join} />

        {/* Once we have the data from Join Component, we are passsed at Chat component. */}
        <Route path="/chat" component={Chat} />
    </Router>
)

export default App;